<template>
    <v-card>
        <v-card-title>{{ creating ? "Creando" : "Editando" }}</v-card-title>
        <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <slot name="form" v-bind:object="object"></slot>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-btn color="blue" @click="onGuardar">{{ creating ? "Guardar" : "Actualizar" }}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    //creating es para controlar el estado de 'editando' vs 'creando'
    //newObject es el objeto por defecto con campos vacios
    //editObject se pasa cuando el estado es 'editando' (creating = false)
    data() {
        return {
            object: null
        }
    },
    props: ["creating", "editObject", "newObject", "service"],
    methods: {
        setupObject() {
            this.creating ? (this.object = { ...this.newObject }) : (this.object = { ...this.editObject })
        },
        save() {
            this.service.create(this.object).then(saved => {
                this.object = { ...this.newObject }
                this.$emit("created", saved)
            })
        },
        update() {
            this.service.update(this.object).then(updated => {
                this.object = { ...this.newObject }
                this.$emit("updated", updated)
            })
        },
        onGuardar() {
            this.creating ? this.save() : this.update()
        }
    },
    watch: {
        creating(oldVal, newVal) {
            this.setupObject()
        }
    },
    created() {
        this.setupObject()
    }
}
</script>

<style></style>
